import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { oneOf, oneOfType, arrayOf, node } from 'prop-types';
import styled, { css } from 'styled-components';
import checkSvg from '../../static/icons/check.svg.js';
import { LIST_VARIANTS, LIST_TYPES } from './constants.js';
export { LIST_TYPES, LIST_VARIANTS } from './constants.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
const List = /*#__PURE__*/styled.ul.withConfig({
  displayName: "list__List",
  componentId: "sc-ysyucw-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0;\n  padding-inline-start: 1.5em;\n\n  ", "\n"])), _ref => {
  let {
    theme,
    variant
  } = _ref;
  switch (variant) {
    case LIST_VARIANTS.CHECK:
      {
        return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          list-style: none;\n\n          > li {\n            position: relative;\n\n            ::before {\n              content: '';\n              position: absolute;\n              top: 0.33em;\n              left: -1.5em;\n              display: inline-block;\n              height: 1em;\n              width: 1em;\n              background-image: url(", ");\n              background-size: contain;\n              background-repeat: no-repeat;\n\n              [dir='rtl'] & {\n                left: auto;\n                right: -1.5em;\n              }\n            }\n          }\n        "])), checkSvg);
      }
    case LIST_VARIANTS.PLAIN:
      {
        return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n          list-style: none;\n          margin: 0;\n          padding: 0;\n        "])));
      }
    case LIST_VARIANTS.SIMPLE:
      {
        return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          list-style: none;\n          margin: 0;\n          padding: 0;\n          & > li {\n            display: flex;\n            justify-content: space-between;\n            border-bottom: 1px solid ", ";\n\n            &:last-child {\n              border-bottom: none;\n            }\n\n            & > a {\n              display: flex;\n              align-items: center;\n              justify-content: space-between;\n              width: 100%;\n              padding: ", "\n                ", ";\n              text-decoration: none;\n\n              &:hover,\n              &:active,\n              &:focus {\n                background-color: ", ";\n              }\n            }\n          }\n        "])), theme.colors.accents.muted, theme.spacing.quarterSpacing, theme.spacing.halfSpacing, theme.colors.opacities.invertedSubtle);
      }
    // no default
  }
});

const ListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "list__ListItem",
  componentId: "sc-ysyucw-1"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 0;\n"])));
List.propTypes = {
  as: oneOf(Object.values(LIST_TYPES)),
  children: oneOfType([arrayOf(node), node]).isRequired,
  variant: oneOf(Object.values(LIST_VARIANTS))
};
List.defaultProps = {
  as: LIST_TYPES.DEFAULT,
  variant: LIST_VARIANTS.STANDARD
};

export { List, ListItem };
